import React, { useEffect, useState } from 'react';
import axios from 'axios';

function Home() {
  const [doctors, setDoctors] = useState([]);
  const [loadingDoctors, setLoadingDoctors] = useState(true);

  useEffect(() => {
    // Fetch doctors for home page
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL || 'https://col2c.com/api'}/doctors/home`);
        if (response.data.success) {
          setDoctors(response.data.data);
        }
      } catch (error) {
        console.error('Error loading doctors:', error);
      } finally {
        setLoadingDoctors(false);
      }
    };

    fetchDoctors();
    // Load external CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = '/css/styles.css';
    link.id = 'home-styles';
    document.head.appendChild(link);

    // Check if script is already loaded
    const existingScript = document.getElementById('home-main-js');
    if (!existingScript) {
      // Load external JS
      const script = document.createElement('script');
      script.src = '/js/main.js';
      script.id = 'home-main-js';
      script.async = true;
      document.body.appendChild(script);
    }

    // Cleanup function
    return () => {
      const linkToRemove = document.getElementById('home-styles');
      if (linkToRemove) {
        document.head.removeChild(linkToRemove);
      }
      // Don't remove the script on cleanup to avoid re-execution issues
    };
  }, []);

  return (
    <>
      {/* Navigation */}
      <nav className="navbar">
        <div className="container">
          <div className="nav-brand">
            <h1>CENTRO OFTALMOLÓGICO<br /><span className="brand-subtitle">LOS DOS CAMINOS</span></h1>
          </div>
          <button className="mobile-menu-toggle" aria-label="Toggle menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
          <ul className="nav-menu">
            <li><a href="#inicio">Inicio</a></li>
            <li><a href="#nosotros">Nosotros</a></li>
            <li><a href="#profesionales">Profesionales</a></li>
            <li><a href="#servicios">Servicios</a></li>
            <li><a href="#optica">Óptica</a></li>
            <li><a href="#contacto">Contacto</a></li>
            <li><a href="#cita" className="btn-cita">Solicita tu Cita</a></li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="inicio" className="hero">
        <div className="hero-overlay"></div>
        <div className="container hero-content">
          <h2>Cuidamos tu Visión con Excelencia</h2>
          <p>Centro especializado en oftalmología con tecnología de vanguardia y profesionales altamente calificados</p>
          <div className="hero-buttons">
            <a href="#cita" className="btn btn-primary">Solicita tu Cita</a>
            <a href="#servicios" className="btn btn-secondary">Conoce Nuestros Servicios</a>
          </div>
        </div>
      </section>

      {/* Quick Access */}
      <section className="quick-access">
        <div className="container">
          <div className="access-grid">
            <div className="access-card">
              <div className="access-icon">👁️</div>
              <h3>Consultas</h3>
              <p>Atención especializada en todas las áreas de oftalmología</p>
              <a href="#servicios" className="access-link">Ver más</a>
            </div>
            <div className="access-card">
              <div className="access-icon">🔬</div>
              <h3>Cirugías</h3>
              <p>Procedimientos quirúrgicos con tecnología de punta</p>
              <a href="#servicios" className="access-link">Ver más</a>
            </div>
            <div className="access-card">
              <div className="access-icon">👓</div>
              <h3>Óptica</h3>
              <p>Monturas y cristales de las mejores marcas</p>
              <a href="#optica" className="access-link">Ver más</a>
            </div>
            <div className="access-card">
              <div className="access-icon">🎭</div>
              <h3>Prótesis Oculares</h3>
              <p>Fabricación personalizada de prótesis oculares</p>
              <a href="#servicios" className="access-link">Ver más</a>
            </div>
          </div>
        </div>
      </section>

      {/* Nosotros Section */}
      <section id="nosotros" className="nosotros">
        <div className="container">
          <h2 className="section-title">Sobre Nosotros</h2>
          <div className="nosotros-content">
            <div className="nosotros-text">
              <h3>Nuestra Visión</h3>
              <p>Somos un centro de salud privado especializado en oftalmología, orientado a la atención integral de pacientes con patologías oculares, principalmente de mediana y avanzada edad. Nuestro enfoque se centra en la resolución quirúrgica de enfermedades oculares, con especial atención en áreas como la cirugía plástica ocular (oculoplastia) y la corrección de cataratas.</p>

              <h3>Nuestro Equipo</h3>
              <p>Contamos con un equipo médico altamente calificado en todas las subespecialidades oftalmológicas, incluyendo glaucoma, retina, cirugía refractiva, entre otras. Además, ofrecemos servicios complementarios como óptica, aplicación de rellenos faciales y fabricación personalizada de prótesis oculares.</p>
            </div>
            <div className="nosotros-image">
              <img src="/images/Logo_col2c.jpeg" alt="Logo COL2C" style={{ width: '100%', height: 'auto', objectFit: 'contain', borderRadius: '15px' }} />
            </div>
          </div>
        </div>
      </section>

      {/* Profesionales Section */}
      <section id="profesionales" className="profesionales">
        <div className="container">
          <h2 className="section-title">Nuestros Profesionales</h2>
          <p className="section-subtitle">Equipo médico especializado en todas las áreas de oftalmología</p>

          {loadingDoctors ? (
            <p style={{ textAlign: 'center', padding: '2rem' }}>Cargando profesionales...</p>
          ) : doctors.length === 0 ? (
            <p style={{ textAlign: 'center', padding: '2rem' }}>No hay profesionales disponibles en este momento.</p>
          ) : (
            <div className="profesionales-grid">
              {doctors.map((doctor) => {
                const fullName = `${doctor.firstName} ${doctor.secondName || ''} ${doctor.firstLastName} ${doctor.secondLastName || ''}`.replace(/\s+/g, ' ').trim();
                const prefix = doctor.gender === 'femenino' ? 'Dra.' : 'Dr.';
                // Always use company WhatsApp number
                const whatsappNumber = '584142529213';
                const whatsappMessage = `Hola, estoy interesado en una consulta con ${prefix} ${fullName}`;
                const specialties = doctor.specialty.join(', ');

                // Format schedule
                const scheduleText = doctor.schedule && doctor.schedule.length > 0
                  ? doctor.schedule
                      .filter(s => s.isActive && s.type === 'recurring')
                      .map(s => `${s.day}: ${s.startTime} - ${s.endTime}`)
                      .join(', ')
                  : 'Consultar horarios';

                return (
                  <div key={doctor._id} className="doctor-card">
                    {doctor.profileImage ? (
                      <div className="doctor-image" style={{
                        backgroundImage: `url(${process.env.REACT_APP_API_URL?.replace('/api', '') || 'https://col2c.com'}${doctor.profileImage})`
                      }}></div>
                    ) : (
                      <div className="doctor-image"></div>
                    )}
                    <div className="doctor-info">
                      <h3>{prefix} {fullName}</h3>
                      <span className="mpps-badge">MPPS: {doctor.mpps}</span>
                      <p className="specialty">{specialties}</p>
                      {doctor.biography && (
                        <p className="bio">{doctor.biography.substring(0, 150)}{doctor.biography.length > 150 ? '...' : ''}</p>
                      )}
                      <p className="schedule">{scheduleText}</p>
                      <a
                        href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
                        className="btn btn-whatsapp"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Solicitar Cita
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* Servicios Section */}
      <section id="servicios" className="servicios">
        <div className="container">
          <h2 className="section-title">Nuestros Servicios</h2>
          <div className="servicios-grid">
            <div className="servicio-card">
              <h3>Cirugía de Cataratas</h3>
              <p>Tratamiento avanzado para la corrección de cataratas con tecnología de última generación</p>
            </div>
            <div className="servicio-card">
              <h3>Oculoplastia</h3>
              <p>Cirugía plástica ocular para corrección estética y funcional</p>
            </div>
            <div className="servicio-card">
              <h3>Tratamiento de Glaucoma</h3>
              <p>Diagnóstico y tratamiento especializado para el control del glaucoma</p>
            </div>
            <div className="servicio-card">
              <h3>Enfermedades de Retina</h3>
              <p>Atención especializada en patologías retinianas</p>
            </div>
            <div className="servicio-card">
              <h3>Cirugía Refractiva</h3>
              <p>Corrección de miopía, hipermetropía y astigmatismo</p>
            </div>
            <div className="servicio-card">
              <h3>Prótesis Oculares</h3>
              <p>Fabricación personalizada de prótesis oculares</p>
            </div>
            <div className="servicio-card">
              <h3>Tratamientos Estéticos Faciales</h3>
              <p>Procedimientos de rejuvenecimiento y armonización facial</p>
            </div>
            <div className="servicio-card">
              <h3>Óptica</h3>
              <p>Venta de monturas, lentes y productos oftalmológicos</p>
            </div>
          </div>
        </div>
      </section>

      {/* Óptica Section */}
      <section id="optica" className="optica">
        <div className="container">
          <h2 className="section-title">Nuestra Óptica</h2>
          <p className="section-subtitle">Monturas y cristales de las mejores marcas</p>
          <div className="optica-info">
            <p>Contamos con una amplia selección de monturas y lentes de las mejores marcas internacionales. Nuestro personal especializado te ayudará a encontrar la mejor opción según tus necesidades.</p>
            <a href="https://wa.me/584142529213?text=Hola,%20deseo%20información%20sobre%20monturas%20y%20lentes" className="btn btn-primary" target="_blank" rel="noopener noreferrer">Consultar Disponibilidad</a>
          </div>
        </div>
      </section>

      {/* Cita Section */}
      <section id="cita" className="cita">
        <div className="container">
          <h2 className="section-title">Solicita tu Cita</h2>
          <div className="cita-content">
            <div className="cita-form">
              <form id="citaForm">
                <div className="form-group">
                  <label htmlFor="nombre">Nombre Completo *</label>
                  <input type="text" id="nombre" name="nombre" required />
                </div>
                <div className="form-group">
                  <label htmlFor="telefono">Teléfono *</label>
                  <input type="tel" id="telefono" name="telefono" required />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input type="email" id="email" name="email" />
                </div>
                <div className="form-group">
                  <label htmlFor="especialidad">Especialidad</label>
                  <select id="especialidad" name="especialidad">
                    <option value="">Seleccione una especialidad</option>
                    <option value="cataratas">Cataratas</option>
                    <option value="glaucoma">Glaucoma</option>
                    <option value="retina">Retina</option>
                    <option value="refractiva">Cirugía Refractiva</option>
                    <option value="oculoplastia">Oculoplastia</option>
                    <option value="general">Consulta General</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="fecha">Fecha Preferida</label>
                  <input type="date" id="fecha" name="fecha" />
                </div>
                <div className="form-group">
                  <label htmlFor="mensaje">Mensaje (opcional)</label>
                  <textarea id="mensaje" name="mensaje" rows="4"></textarea>
                </div>
                <button type="submit" className="btn btn-primary">Enviar Solicitud</button>
              </form>
            </div>
            <div className="cita-info">
              <h3>También puedes contactarnos por:</h3>
              <div className="contact-methods">
                <div className="contact-method">
                  <strong>WhatsApp</strong>
                  <p>+58 414 2529213</p>
                </div>
                <div className="contact-method">
                  <strong>Teléfono</strong>
                  <p>+58 414 2529213</p>
                </div>
                <div className="contact-method">
                  <strong>Horario</strong>
                  <p>Lun - Vie: 8:00 AM - 5:00 PM<br />Sáb: Cita Previa</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contacto Section */}
      <section id="contacto" className="contacto">
        <div className="container">
          <h2 className="section-title">Contacto y Ubicación</h2>
          <div className="contacto-grid">
            <div className="contacto-info">
              <div className="info-item">
                <h3>📍 Ubicación</h3>
                <p>Centro Empresarial Qvadra<br />
                  Av. Sucre con Av. Rómulo Gallegos<br />
                  Piso 1, Oficina N° 9<br />
                  Sector Los Dos Caminos<br />
                  Caracas, Municipio Sucre, Estado Miranda<br />
                  Código Postal: 1071<br />
                  Venezuela</p>
              </div>
              <div className="info-item">
                <h3>📞 Teléfono</h3>
                <p>+58 414 2529213</p>
              </div>
              <div className="info-item">
                <h3>⏰ Horarios</h3>
                <p>Lun - Vie: 8:00 AM - 5:00 PM<br />
                  Sáb: Cita Previa</p>
              </div>
              <div className="info-item">
                <h3>📧 Email</h3>
                <p>info@col2c.com</p>
              </div>
            </div>
            <div className="contacto-map">
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=10.496078916451745,-66.83509468292712"
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'block', position: 'relative', cursor: 'pointer' }}
              >
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d980.6247863934358!2d-66.83509468292712!3d10.496078916451745!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c2a58b5e5c7b5b5%3A0x467cb29c8e5e5c0a!2sCentro%20Empresarial%20Qvadra!5e0!3m2!1ses!2sve!4v1647890123456!5m2!1ses!2sve"
                  width="100%"
                  height="400"
                  style={{ border: 0, pointerEvents: 'none' }}
                  allowFullScreen=""
                  loading="lazy"
                  title="Mapa de ubicación">
                </iframe>
              </a>
              <p style={{ marginTop: '1rem', textAlign: 'center', color: '#666', fontSize: '0.95rem' }}>
                📍 <strong>Punto de referencia:</strong> Cerca de la estación de metro Los Dos Caminos, frente al C.C. Millenium<br />
                <em style={{ fontSize: '0.85rem' }}>Haz clic en el mapa para obtener direcciones</em>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>CENTRO OFTALMOLÓGICO<br />LOS DOS CAMINOS</h3>
              <p>RIF: J-50692449-8</p>
            </div>
            <div className="footer-section">
              <h4>Enlaces Rápidos</h4>
              <ul>
                <li><a href="#inicio">Inicio</a></li>
                <li><a href="#nosotros">Nosotros</a></li>
                <li><a href="#profesionales">Profesionales</a></li>
                <li><a href="#servicios">Servicios</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Contacto</h4>
              <p>+58 414 2529213<br />
                Lun - Vie: 8:00 AM - 5:00 PM<br />
                Sáb: Cita Previa</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Centro Oftalmológico Los Dos Caminos, C.A. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <a href="https://wa.me/584142529213?text=Hola,%20deseo%20información%20sobre%20sus%20servicios" className="whatsapp-float" target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp">
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-5.247 1.405 1.405-5.235-0.321-0.527c-1.343-2.21-2.053-4.73-2.053-7.281 0-7.444 6.056-13.5 13.5-13.5s13.5 6.056 13.5 13.5c0 7.444-6.056 13.5-13.5 13.5zM22.258 18.744c-0.392-0.196-2.314-1.142-2.673-1.273s-0.619-0.196-0.88 0.196c-0.261 0.392-1.011 1.273-1.239 1.534s-0.457 0.294-0.849 0.098c-0.392-0.196-1.653-0.609-3.148-1.943-1.163-1.039-1.948-2.322-2.175-2.714s-0.024-0.604 0.172-0.799c0.176-0.175 0.392-0.457 0.588-0.686s0.261-0.392 0.392-0.653c0.131-0.261 0.065-0.49-0.033-0.686s-0.88-2.119-1.205-2.901c-0.317-0.762-0.639-0.658-0.88-0.671-0.228-0.012-0.489-0.015-0.75-0.015s-0.685 0.098-1.044 0.49c-0.359 0.392-1.37 1.338-1.37 3.261s1.403 3.785 1.599 4.046c0.196 0.261 2.76 4.212 6.688 5.908 0.934 0.404 1.664 0.645 2.232 0.825 0.941 0.3 1.797 0.257 2.474 0.156 0.755-0.113 2.314-0.946 2.641-1.858s0.327-1.696 0.229-1.858c-0.098-0.163-0.359-0.261-0.75-0.457z" fill="currentColor" />
        </svg>
      </a>
    </>
  );
}

export default Home;
